import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number | null | undefined, currency: string | null | undefined = 'USD') {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  // Use a try-catch block in case of an invalid currency code at runtime
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(value);
  } catch (e) {
    console.warn(`Invalid currency code: ${currency}. Falling back to USD.`);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  }
}
